import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import resourcesItemIcon from '@/png-icons/mini_icon_recursos.png';
import ResourcesIcon from '@/svg-icons/resources';

const ResourcesSection = ({ data }) => {
  const url = data?.envelope_url || data?.form?.sender_view_url;

  if (!url) return null;

  return (
    <div className="flex items-start pr-[2rem] py-[1rem]">
      <ResourcesIcon viewBox="0 0 34.016 34.016" className="text-[calc(14px+0.56rem)] mt-[0.3rem] mr-[0.9rem] flex-shrink-0 w-[calc(14px+0.56rem)] h-[calc(14px+0.56rem)]" />
      <div className="flex-1">
        <p className="font-bold text-[calc(6px+0.3rem)] my-[0.5rem]">
          <FormattedMessage id="resources" />
        </p>
        <div className="flex items-center">
          <div className="ml-[0.5rem] mr-[calc(6px+0.56rem)] flex-shrink-0">
            <img src={resourcesItemIcon} alt="" />
          </div>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#00bbdd] underline text-[calc(6px+0.3rem)]"
            data-cy="order-details-sender-view-url"
          >
            <FormattedMessage id="SIGNED_FILES" />
          </a>
        </div>
      </div>
    </div>
  );
};

ResourcesSection.propTypes = {
  data: PropTypes.object,
};

ResourcesSection.defaultProps = {
  data: null,
};

export default ResourcesSection;
